import { Directive } from '@angular/core';


@Directive({
    selector: 'select2-label',
    standalone: false
})
export class Select2Label {}
